import PropTypes from 'prop-types';
import { useEffect, useMemo } from 'react';
// rtl
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
// emotion
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
// @mui
import { useTheme } from '@mui/material/styles';

// ----------------------------------------------------------------------

ThemeRtlLayout.propTypes = {
  children: PropTypes.node,
};

export default function ThemeRtlLayout({ children }) {
  const theme = useTheme();

  useEffect(() => {
    document.dir = theme.direction;
  }, [theme.direction]);

  // 依方向建立一次 emotion cache（LTR/RTL 都走這裡），避免每次 render 重建 cache
  // 導致樣式被重新插入。
  const emotionCache = useMemo(
    () =>
      createCache({
        key: theme.direction === 'rtl' ? 'rtl' : 'css',
        stylisPlugins: theme.direction === 'rtl' ? [prefixer, rtlPlugin] : [],
        // speedy: true —— 用 CSSOM insertRule 把規則插進同一個 <style>。
        // emotion 開發模式預設 speedy=false，一條規則就建立一個 <style> 標籤，
        // 大表單（如報價單編輯頁）一次掛載上千條規則會讓主執行緒卡好幾秒。
        // production 本來就是 speedy，這裡只是讓開發模式一致。
        // 代價：DevTools Elements 面板的 <style> 看不到 emotion 樣式內容
        // （Styles 面板仍可看），需要直接檢視樣式原文時請暫時改回 false。
        speedy: true,
      }),
    [theme.direction]
  );

  return <CacheProvider value={emotionCache}>{children}</CacheProvider>;
}
